module.exports = __webpack_public_path__ + "static/media/check.a8a0c63e.svg";